import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthInterceptorService } from './services/auth-interceptor.service';
import { Sim } from '@ionic-native/sim/ngx';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { SMS } from '@ionic-native/sms/ngx';
import { Contacts } from '@ionic-native/contacts/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { VoipCallComponent } from './components/voip-call/voip-call.component';
import * as Sentry from '@sentry/capacitor';
import { init as sentryAngularInit, createErrorHandler }  from "@sentry/angular";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Init by passing the sibling SDK's init as the second parameter.

Sentry.init({
  dsn: "https://fbc576c2250d9ea813a9f8bca22fd45d@o4508972652822528.ingest.de.sentry.io/4508972654854224",
  release: "0.11",
}, sentryAngularInit);


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler(),
    },
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    Sim,
    AndroidPermissions,
    CallNumber,
    SMS,
    SmsRetriever,
    Contacts,
    ScreenOrientation,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
